<template>
  <v-dialog v-model="showWhatsNew" max-width="1050px">
    <v-card>
      <v-form>
        <v-container grid-list-lg fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="headline">What's New! v{{version}}</div>
            </v-flex>
            <v-list two-line subheader style="width: 100%">
              <v-subheader>Notes</v-subheader>
              <v-tooltip
                top
                v-for="item in whatsNew"
                :key="item.title"
                max-width="400px"
                :disabled="!item.tooltip"
              >
                <v-list-tile avatar slot="activator">
                  <v-list-tile-avatar>
                    <v-icon :color="item.color">{{ item.icon }}</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <span v-if="item.tooltip" v-html="item.tooltip"></span>
              </v-tooltip>
              <v-divider inset></v-divider>
            </v-list>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="primaryGrey" flat @click="close(false)">Close</v-btn>
          <v-btn :color="primaryNeutral" @click="close(true)" flat>Don't Show again</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      version: '2.2.1 - Feature Update ',
      showWhatsNew: false,
    }
  },
  methods: {
    close(bool) {
      if (bool) {
        localStorage.setItem(`dontShowWhatsNewv${this.version}`, true)
      }
      this.showWhatsNew = false
    },
  },
  computed: {
    // Driver
    // - Add "induction card number" triggers save button
    //  - Added VIN to driver card

    // Batch Allocation
    //  - Exports induction card number

    // Docket
    // - Filter by Weighbridge docket number
    //  - import changes: Break by Site
    //  - import changes: A, B... suffix

    // Compliance
    // - Hide drivers/vehicles based on inactive Subbies

    // Audit feature

    // General
    //  - Added "Quick" de-select button
    //  - Master file card adjustments
    //  - Add Rates to Main menu
    //  - Select Single date in filter

    // *Allocation batches - Highlight duplicate batches for Driver or Vehicle
    // *Allocations - Display Day/Night field
    // *Edit Dockets – now has an options to toggle Night rate
    // *Settings menu – Admins lock billing periods for data entry
    // *Master file "Requests" can now be created and approved by administrators
    // Allocation batches edit screen – Add vehicle type to Vehicle selection
    // *Allocations batches – fix Driver / Vehicle / Subcontractor / Induction link
    // HR app: Classification/Award field - increase allowed characters

    whatsNew() {
      return [
        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'Update: Added created / updated by to masterfiles',
          subtitle:
            ' Created / updated by has been added to sites, tips, spoils, sub-contractors, drivers, vehicles',
        },
        {
          icon: this.$store.state.global.pages.audit.icon,
          color: this.$store.state.global.pages.audit.color,
          title: 'New Feature: Settings menu - active/closed Billing Periods ',
          subtitle:
            ' Billing periods can now be created, activated and closed in the settings menu',
        },
        {
          icon: this.$store.state.global.pages.allocation.icon,
          color: this.$store.state.global.pages.allocation.color,
          title:
            'New Feature: Allocations Batch hightlight duplicate driver/vehicle',
          subtitle:
            ' Adding allocation batches hightlights duplicate driver or vehcile',
        },
        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'New Feature: Master file requests / approvals',
          subtitle: ' Master files requests can now be created and approved',
          tooltip:
            'Master files (site, tip, spoil, sub-contractor, driver, vehicle) requests can now be created by data entry users and approved by administrators ',
        },
        {
          icon: this.$store.state.global.pages.allocation.icon,
          color: this.$store.state.global.pages.allocation.color,
          title: 'Update: Allocations display day/night field',
          subtitle: ' Allocations register now displays the day/night field',
        },
        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'Update: Edit docket line - Night rate',
          subtitle: ' Edit docket line now allows toggle Night rate',
        },
        {
          icon: this.$store.state.global.pages.allocation.icon,
          color: this.$store.state.global.pages.allocation.color,
          title:
            'Fix: Allocation Batch - Fix Driver / Vehicle / Subcontractor / Induction link',
          subtitle:
            '  Allocation Batch lines now link correctly to Drivers, Vehicles, Subcontractors and Inductions',
        },
        {
          icon: this.$store.state.global.pages.audit.icon,
          color: this.$store.state.global.pages.audit.color,
          title: 'New Feature: Audit Tracking',
          subtitle:
            ' All files now have an audit trail, available from the Audit Register',
        },
        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'New feature: Single date option',
          subtitle:
            ' Register date filters now include a single date option when searching',
        },

        {
          icon: this.$store.state.global.pages.vehicle.icon,
          color: this.$store.state.global.pages.vehicle.color,
          title: 'New feature: Added Vehicle Identification Number (VIN)',
          subtitle: ' Vehicle card now includes a VIN',
        },
        {
          icon: this.$store.state.global.pages.allocation.icon,
          color: this.$store.state.global.pages.allocation.color,
          title: 'New Feature: Batch Allocations confirmations',
          subtitle:
            ' Batch Allocations require Tip, Site and Admendments confirmation',
        },
        {
          icon: this.$store.state.global.pages.allocation.icon,
          color: this.$store.state.global.pages.allocation.color,
          title: 'New Feature: Void Allocations',
          subtitle: ' Allocations can now be voided and a note can be recorded',
        },
        {
          icon: this.$store.state.global.pages.allocation.icon,
          color: this.$store.state.global.pages.allocation.color,
          title:
            'New Feature: Batch Allocations export includes Induction card #',
          subtitle:
            ' Batch Allocations export now includes Induction card number',
        },
        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'New feature: Import docket include A-Z suffix',
          subtitle: ' Docket import - Break by site includes an A-Z suffix',
        },

        {
          icon: this.$store.state.global.pages.compliance.icon,
          color: this.$store.state.global.pages.compliance.color,
          title:
            'New feature: Hide compliance records based on active / inactive  ',
          subtitle:
            ' Added filter to hide or display inactive compliance records',
        },

        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'New feature: Quick deselect option',
          subtitle:
            ' Registers now include a quick deselect button to clear any selected records',
        },

        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'Update: Moved Rates to main menu',
          subtitle: ' Rates register has been moved to the main menu',
        },

        {
          icon: this.$store.state.global.pages.driver.icon,
          color: this.$store.state.global.pages.driver.color,
          title: 'Fix: Induction card / save button',
          subtitle:
            ' Changing the induction card number now triggers the save button',
        },

        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'Update: Import import breaks by Site',
          subtitle: ' Docket import now breaks by site',
        },

        {
          icon: this.$store.state.global.pages.docket.icon,
          color: this.$store.state.global.pages.docket.color,
          title: 'Update: Master file card adjustments',
          subtitle: ' Small changes to master files card display',
        },

        {
          icon: this.$store.state.global.pages.compliance.icon,
          color: this.$store.state.global.pages.compliance.color,
          title: 'New Feature: Show Compliance count',
          subtitle:
            ' Compliance - Show Compliance count in Contractors, Vehicles and Drivers',
        },
        // {
        //   icon: this.$store.state.global.pages.docket.icon,
        //   color: this.$store.state.global.pages.docket.color,
        //   title: "Update: Adjustment to Electronic Docket Import",
        //   subtitle: " Better error reporting on docket imports",
        // },
        // {
        //   icon: this.$store.state.global.pages.tipping.icon,
        //   color: this.$store.state.global.pages.tipping.color,
        //   title: "New Feature: Tipping - Weighbridge docket #",
        //   subtitle: " Tipping Module - Tipping docket import includes Weighbridge docket number ",
        //   tooltip:
        //     "Weighbridge docket number added to the tipping module import - column header 'WB-DocketNumber'."
        // },
        // {
        //   icon: this.$store.state.global.pages.tipping.icon,
        //   color: this.$store.state.global.pages.tipping.color,
        //   title: "New Feature: Tipping - Match by Weighbridge Docket #",
        //   subtitle: " Tipping Module - W/B Docket number used for matching trips/dockets",
        //   // tooltip:
        //   //   "The Weighbridge docket number is used for matching dockets/trips, then matches by Tip/Date/Vehicle/(Day/Night)."
        // },
        // {
        //   icon: this.$store.state.global.pages.allocation.icon,
        //   color: this.$store.state.global.pages.allocation.color,
        //   title: "New Feature: Allocation - Compliance warnings are displayed",
        //   subtitle: " Allocation/Compliance - Compliance issues are displayed in add allocation",
        //   tooltip:
        //     "Compliance warnings are now displayed when a Driver, Vehicle or Sub-contractor is selected during add allocation."
        // },
        // {
        //   icon: this.$store.state.global.pages.contractor.icon,
        //   color: this.$store.state.global.pages.contractor.color,
        //   title: "Update: Contractor, Driver, Vehicle counts",
        //   subtitle: " Contractor, Driver, Vehicle counts are now calculated in a batch",
        //   tooltip: "Contractor, Driver, Vehicle counts are now calculated in a batch process that runs once per day."
        // },
        // {
        //   icon: this.$store.state.global.pages.allocation.icon,
        //   color: this.$store.state.global.pages.allocation.color,
        //   title: 'Update: Automated task "Inactive" now considers allocations',
        //   subtitle: " Allocations"
        //   //tooltip: 'Projects can now be flagged as allocation matching by SITE or PROJECT, maintained in the project card.',
        // }
        // {
        //     icon: this.$store.state.global.pages.docket.icon,
        //     color: this.$store.state.global.pages.docket.color,
        //     title: 'Update: Changes to the docket import feature - Calculate using Weighbridge weight, entered in tonnes',
        //     subtitle: 'Allocations',
        // },
        // {
        //     icon: this.$store.state.global.pages.docket.icon,
        //     color: this.$store.state.global.pages.docket.color,
        //     title: 'New field: Weighbridge docket # available in edit trip screen',
        //     subtitle: 'Dockets',
        // },
      ]
    },
  },
  mounted() {
    var dontShowWhatsNew = localStorage.getItem(
      `dontShowWhatsNewv${this.version}`
    )
    if (!dontShowWhatsNew) {
      this.showWhatsNew = true
    }
  },
}
</script>

<style>
/* .update-title {
        text-overflow: initial;
        overflow: auto;
        height: auto;
        white-space: initial;
    }

    .tile-wrapper .v-list__tile {
        height: auto
    } */
</style>


